/** Convert API / Mongoose / unknown errors into a safe display string */
export const toErrorMessage = (err, fallback = "Something went wrong") => {
  if (!err) return fallback;
  if (typeof err === "string") return err;

  const candidates = [
    err.message,
    err.data?.message,
    err.response?.data?.message,
    err._message,
    err.data,
  ];

  for (const candidate of candidates) {
    if (!candidate) continue;
    if (typeof candidate === "string") return candidate;
    if (typeof candidate === "object") {
      if (typeof candidate.message === "string") return candidate.message;
      if (typeof candidate._message === "string") return candidate._message;
      if (candidate.errors && typeof candidate.errors === "object") {
        const parts = Object.values(candidate.errors)
          .map((e) => (typeof e === "string" ? e : e?.message))
          .filter(Boolean);
        if (parts.length) return parts.join(", ");
      }
    }
  }

  try {
    return JSON.stringify(err.data || err.message || err);
  } catch {
    return fallback;
  }
};
